import { render, staticRenderFns } from "./productGridTable.vue?vue&type=template&id=d70471d0&scoped=true&"
import script from "./productGridTable.vue?vue&type=script&lang=js&"
export * from "./productGridTable.vue?vue&type=script&lang=js&"
import style0 from "./productGridTable.vue?vue&type=style&index=0&id=d70471d0&prod&lang=css&"
import style1 from "./productGridTable.vue?vue&type=style&index=1&id=d70471d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d70471d0",
  null
  
)

export default component.exports